module.exports = __WEBPACK_EXTERNAL_MODULE_12__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Regular","amd":"Regular","commonjs":"regularjs","commonjs2":"regularjs"}
// module id = 12
// module chunks = 0